export default "__VITE_ASSET__Cs77fIQF__"